function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThumbUp = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _SVG = require("../../SVG");
var _styles = require("../../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["size", "color", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var ThumbUp = exports.ThumbUp = (0, _react.memo)(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? (0, _styles.getREM)(1.5) : _ref$size,
    color = _ref.color,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors;
  return (0, _jsxRuntime.jsxs)(_SVG.SVG.Svg, Object.assign({
    testID: "ThumbUp",
    viewBox: "0 0 17 16",
    fill: "none",
    style: [{
      width: size,
      height: size
    }, style],
    title: "thumb icon"
  }, props, {
    children: [(0, _jsxRuntime.jsx)(_SVG.SVG.Path, {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5085 5.43603H11.6547C11.8915 4.48642 12.5295 4.12503 12.5295 2.799C12.5295 0.378802 9.77296 -1.68468 9.07754 2.03634C8.87072 3.03837 6.59008 6.66472 5.57569 6.74461C5.23418 6.777 4.94757 7.0636 4.94757 7.4051V14.01C4.94757 14.3714 5.2567 14.658 5.60558 14.668C5.96696 14.6805 6.58507 14.8949 7.23308 15.1217C8.34711 15.5031 9.73792 15.989 11.211 15.989C13.1228 15.989 15.2885 16.0189 15.0744 13.3196C15.6328 12.7863 15.8496 11.8815 15.6328 11.1463C16.1312 10.4783 16.1836 9.71564 15.9219 8.95046C15.9219 8.95046 16.3731 5.4361 14.5087 5.4361L14.5085 5.43603Z",
      fill: color != null ? color : colors.text
    }), (0, _jsxRuntime.jsx)(_SVG.SVG.Path, {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.287 7.41489V14.0096C4.287 14.3685 3.98788 14.6676 3.62651 14.6676H0.660492C0.299108 14.6676 0 14.371 0 14.0096V7.41489C0 7.0535 0.299119 6.75439 0.660492 6.75439H3.62651C3.98789 6.75439 4.287 7.05351 4.287 7.41489Z",
      fill: color != null ? color : colors.text
    })]
  }));
});